import React, {Fragment} from "react";
import {Grid, Container, Typography, Box, makeStyles} from "@material-ui/core";
import {useBreakpoints} from "../../../hooks";
import PropTypes from "prop-types";
import HtmlComponentWrapper from "./HtmlComponentWrapper";

const useStyles = makeStyles((theme) => ({
    title: {
        marginBottom: theme.spacing(7),
        [theme.breakpoints.down("md")]: {
            marginBottom: theme.spacing(5)
        }
    },
    greenHighlightedTitle: {
        background: `linear-gradient(bottom, ${theme.palette.primary[100]} 60%, transparent 40%)`,
        display: "inline",
        height: theme.spacing(4.5)
    }
}));

const GridLayout3 = ({elements, title, bgColor, titleStyle}) => {

    const classes = useStyles();

    const {isExtraSmallScreen, isSmallScreen} = useBreakpoints();

    return (
        <Box
            bgcolor={bgColor}
            py={3}
        >
            <Container>
                {title &&
                    <Box
                        textAlign={titleStyle?.textAlignment ? titleStyle?.textAlignment.toLowerCase() : "center"}
                        className={classes.title}
                    >
                        <Typography
                            variant={titleStyle?.headingVariant ? titleStyle?.headingVariant : "h2"}
                            className={titleStyle?.headingStyle === "Green highlighted" ? classes.greenHighlightedTitle : ""}
                        >
                            {title}
                        </Typography>
                    </Box>
                }
                <Grid
                    container
                    spacing={(isExtraSmallScreen() || isSmallScreen()) ? 3 : 7}
                >
                    {elements && elements?.map(e => {
                        return (
                            <Fragment
                                key={e?.sys?.id}
                            >
                                {e?.fields?.type === "image_legend" && (isSmallScreen() || isExtraSmallScreen()) ? (
                                    <div/>
                                ) : (
                                    <Grid
                                        item
                                        container
                                        key={e?.sys?.id}
                                        lg={4}
                                        md={4}
                                        sm={6}
                                        xs={12}
                                    >
                                        <HtmlComponentWrapper
                                            htmlComponents={[e]}
                                        />
                                    </Grid>
                                )}
                            </Fragment>
                        );
                    })
                    }
                </Grid>
            </Container>
        </Box>
    );
};

GridLayout3.propTypes = {
    title: PropTypes.string,
    bgColor: PropTypes.string,
    titleStyle: PropTypes.shape({
        target: PropTypes.string,
        textAlignment: PropTypes.string,
        headingVariant: PropTypes.string,
        headingStyle: PropTypes.string
    }),
    elements: PropTypes.array
};

export default GridLayout3;
